import React from "react";
import styled from "styled-components";
import { BookingHeader } from ".";
import { Loading } from "../../../config/StyledComponents";
import EachBookingContainer from "./EachBookingContainer";

const BookingStatusBody = ({
  bookingList,
  handleClick,
  isTableDataLoading,
}) => {
  return (
    <BookingStatusBodyWrapper>
      {!isTableDataLoading ? (
        bookingList && bookingList?.length > 0 ? (
          bookingList.map((eachBooking, index1) => {
            return (
              <EachBookingContainer
                key={index1}
                // onClick={() => handleClick(eachBooking.id)}
              >
                {BookingHeader.map((eachHeader, index2) => {
                  return (
                    <div
                      onClick={() => {
                        eachHeader.key === "requestID" &&
                          handleClick(eachBooking.id);
                      }}
                      key={index2}
                    >
                      {eachHeader.content(eachBooking)}
                    </div>
                  );
                })}
              </EachBookingContainer>
            );
          })
        ) : (
          <Loading>No Records Found</Loading>
        )
      ) : (
        <Loading>Loading...</Loading>
      )}
    </BookingStatusBodyWrapper>
  );
};

export default BookingStatusBody;

const BookingStatusBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  > div:first-child {
    border-radius: 0.5rem 0.5rem 0 0;
  }
  > div:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }
`;
